import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiMacos,
  SiAndroidstudio,
  SiXcode,
  SiDiscord,
} from "react-icons/si";
import { StaggerContainer, StaggerItem } from "../AnimatedSection";
import TechIconCard from "./TechIconCard";
import { CursorIcon, ClaudeIcon } from "./CustomIcons";

const tools = [
  { icon: <CursorIcon />, key: "cursor", name: "Cursor" },
  { icon: <ClaudeIcon />, key: "claude", name: "Claude" },
  { icon: <SiMacos />, key: "macos", name: "macOS" },
  { icon: <SiAndroidstudio />, key: "android-studio", name: "Android Studio" },
  { icon: <SiXcode />, key: "xcode", name: "Xcode" },
  { icon: <SiVisualstudiocode />, key: "vscode", name: "VS Code" },
  { icon: <SiPostman />, key: "postman", name: "Postman" },
  { icon: <SiSlack />, key: "slack", name: "Slack" },
  { icon: <SiDiscord />, key: "discord", name: "Discord" },
  { icon: <SiVercel />, key: "vercel", name: "Vercel" },
];

function Toolstack() {
  return (
    <StaggerContainer>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        {tools.map((tool) => (
          <Col xs={4} md={2} key={tool.key}>
            <StaggerItem>
              <TechIconCard icon={tool.icon} name={tool.name} />
            </StaggerItem>
          </Col>
        ))}
      </Row>
    </StaggerContainer>
  );
}

export default Toolstack;
